export const theme = {
  token: {
    colorPrimary: '#FFD43B',
    colorPrimaryHover: '#e1e1e1',
    colorSplit: '#666666',
    colorBorder: '#484848',
    colorBorderSecondary: '#666666',
    colorPrimaryBorder: '#e1e1e1',
    borderRadius: 0,
    colorLink: '#e1e1e1',
    colorLinkActive: '#FFD43B',
    colorLinkHover: '#FFD43B',
    colorBgBase: '#090909',
    colorPrimaryBg: '#090909',
    colorTextBase: '#e1e1e1',
    colorTextLightSolid: '#090909',
  },
};
